import React, { Fragment, useCallback } from 'react';
import { cn } from '../../utils/cn';
import type { SupportMenuItemProps } from './support-menu-item.types';
import Button from '../../atoms/button';
import { Link } from '../../atoms/link/link';
import { MenuItem } from '../menu-item';

import styles from './support-menu-item.module.css';
import { useSupportMenuItemView } from './use-support-menu-item-view.hook';

const SupportMenuItem: React.FC<SupportMenuItemProps> = ({
    title,
    titleClassname,
    link,
    onPress,
    className,
    supportMenuItemContentProps,
    testID = 'support-menu-item',
}) => {
    const { titleProps, rightIcon } = useSupportMenuItemView({
        titleClassname,
    });

    const supportMenuItemContent = useCallback(() => {
        return (
            <MenuItem
                label={title}
                labelProps={titleProps}
                trailingIconProps={rightIcon}
                {...supportMenuItemContentProps}
                containerClassName={cn(styles.content, supportMenuItemContentProps?.containerClassName)}
            />
        );
    }, [title, titleProps, rightIcon, supportMenuItemContentProps]);

    return (
        <Fragment>
            <Button
                showIf={!link}
                onClick={onPress}
                className={cn(styles.buttonContainer, className)}
                contentClassName={styles.contentWrapper}
                data-testid={testID}
            >
                {supportMenuItemContent()}
            </Button>

            <Link showIf={!!link} className={cn(styles.linkContainer, className)} href={link ?? ''}>
                {supportMenuItemContent()}
            </Link>
        </Fragment>
    );
};

export default SupportMenuItem;
